import { render, staticRenderFns } from "./SystemPermissionGroupItemTreeView.vue?vue&type=template&id=4f229852&scoped=true"
import script from "./SystemPermissionGroupItemTreeView.vue?vue&type=script&lang=js"
export * from "./SystemPermissionGroupItemTreeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f229852",
  null
  
)

export default component.exports